<template>
  <div>
    <span>
      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
        <template v-slot:button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="text-body align-middle mr-25"
          />
        </template>
        <b-dropdown-item @click="onClickEdit">
          <feather-icon icon="EditIcon" class="mr-50" />
          <span>Chỉnh sửa</span>
        </b-dropdown-item>
      </b-dropdown>
    </span>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";

export default {
  props: ["user"],
  components: {
    BDropdown,
    BDropdownItem,
  },

  data() {
    return {};
  },

  methods: {
    onClickEdit() {
      this.$emit("edit-clicked");
    },
  },
};
</script>
